import { getWindowSize, missingWidget } from '../../utils/helpers';
import { updateLinksAttributes } from '../../utils/handleAttributes';
const breakpointMobile = 800;

function customCards() {
  const widgetName = 'customCards';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof customCardsOpts === 'undefined' ? null : customCardsOpts;

  if (!widgetOpts) {
    $(`#${widgetName}`).remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: getWindowSize(breakpointMobile) ? [''] : ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items, $widget);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });
}

function createCustomCards(widgetData, $widget) {
  $widget.find('.card-content').remove();

  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL, PurchaseURL, Description } = widgetData[x];
    const $cardItem = $(this);
    $cardItem.append('<div class="overlay"></div>');

    const learnMoreBtn = URL
      ? `<a href="${URL}" class="button alternative-btn" ${updateLinksAttributes(URL, Title + ' - Learn More')}>More</a>`
      : '';

    const buyBtn = PurchaseURL
      ? `<a href="${PurchaseURL}" class="button" ${updateLinksAttributes(PurchaseURL, Title + ' - Buy Now')}>Buy now</a>`
      : '';

    $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <h3 class="widget-title">${Title}</h3>
              <div class="widget-divider"></div>
            </div>
            <div class="hover-content">
              <div class="cards-buttons-container">
                ${learnMoreBtn}
                ${buyBtn}
              </div>
            
            </div>
          </div>`);

    if (!getWindowSize(breakpointMobile)) {
      updateLinks($cardItem, URL, PurchaseURL, Title);
    }
    validateContent($cardItem, URL, PurchaseURL, Title, Description);
  });
}

function validateContent($item, moreLink, buyLink, itemTitle, itemDescription) {
  $item.removeAttr('target').removeClass('void-link');
  if (
    (moreLink == null || moreLink == undefined) &&
    (buyLink == null || buyLink == undefined) &&
    (itemDescription == null || itemDescription == '')
  ) {
    $item.addClass('void-link');
  }
}

function updateLinks($item, moreLink, buyLink, itemTitle) {
  if (moreLink != null || moreLink != undefined) {
    updateLinksAttributes(moreLink, itemTitle, $item);
  }

  if (buyLink != null || buyLink != undefined) {
    $item.attr('href', buyLink);
    updateLinksAttributes(buyLink, itemTitle, $item);
  }

  if ((moreLink == null || moreLink == undefined) && (buyLink == null || buyLink == undefined)) {
    $item.removeAttr('href');
    updateLinksAttributes(buyLink, itemTitle, $item);
  }
}

export default function updateCards() {
  let isMobile;

  function triggerFeature() {
    const matches = globalThis.matchMedia(`(max-width: ${breakpointMobile}px)`).matches;
    if (matches === isMobile) return;
    isMobile = matches;

    $(`#customCards`).empty();
    customCards();
  }
  triggerFeature();

  $(globalThis).on('resize', triggerFeature);
}
